import { PerformSearchAction, SearchActionTypes } from './ActionTypes';

export function performSearch(searchTerm: string): PerformSearchAction {
  return {
    type: SearchActionTypes.PERFORM_SEARCH,
    searchTerm,
  };
}
